import { getProvider, getWeb3 } from ".";
import config from "../../config/config";

import MafiaBulletFactoryAbi from "../../abis/MafiaBulletFactory.json";
import { ethers } from "ethers";

export const getMafiaBulletFactoryContract = (provider = false) => {
  const web3 = provider ? getProvider() : getWeb3();
  const contractAddress = config.bulletFactoryAddress;
  const MafiaBulletFactoryContract = new web3.eth.Contract(
    MafiaBulletFactoryAbi,
    contractAddress
  );

  return MafiaBulletFactoryContract;
};

export const getCityMarketInfo = async (cityId: number) => {
  const MafiaBulletFactoryContract = getMafiaBulletFactoryContract();
  const cityMarketInfo: any = await MafiaBulletFactoryContract.methods
    .getCityMarketInfo(cityId)
    .call();

  return {
    price: Number(ethers.utils.formatUnits(cityMarketInfo.price, 18)),
    amountLeft: Number(cityMarketInfo.amountLeft),
    lastUpdateTime: Number(cityMarketInfo.lastUpdateTime),
  };
};

export const buyBullets = async (
  account: string,
  bulletAmount: number,
  message: string,
  signature: string
) => {
  const MafiaBulletFactoryContract = getMafiaBulletFactoryContract(true);
  const txData = await MafiaBulletFactoryContract.methods
    .buyBullets(bulletAmount, JSON.stringify(message), signature)
    .send({ from: account });

  return txData;
};

export const claimBulletFactoryProfit = async (
  account: string,
  cityId: number
) => {
  const MafiaBulletFactoryContract = getMafiaBulletFactoryContract(true);
  const txData = await MafiaBulletFactoryContract.methods
    .claimProfit(cityId)
    .send({ from: account });

  return txData;
};

export const getBulletMarketLaunchBlock = async () => {
  const MafiaBulletFactoryContract = getMafiaBulletFactoryContract();
  const launchBlock: number = await MafiaBulletFactoryContract.methods
    .launchBlock()
    .call();
  return Number(launchBlock);
};

export const getBulletMarketUpdateInterval = async () => {
  const MafiaBulletFactoryContract = getMafiaBulletFactoryContract();
  const updateInterval: number = await MafiaBulletFactoryContract.methods
    .updateInterval()
    .call();
  return Number(updateInterval);
};

export const getNextBulletBuyTime = async (account: string) => {
  const MafiaBulletFactoryContract = getMafiaBulletFactoryContract();
  const nextBuyTime: number = await MafiaBulletFactoryContract.methods
    .nextBuyTime(account)
    .call();
  return Number(nextBuyTime);
};

export const reproduceBullets = async (account: string, cityId: number) => {
  const MafiaBulletFactoryContract = getMafiaBulletFactoryContract(true);
  const txData = await MafiaBulletFactoryContract.methods
    .reproduceBullets(cityId)
    .send({ from: account });

  return txData;
};

export const getLastPriceUpdateTime = async (cityId: number) => {
  const MafiaBulletFactoryContract = getMafiaBulletFactoryContract();
  const lastPriceUpdateTime: number = await MafiaBulletFactoryContract.methods
    .lastPriceUpdateTime(cityId)
    .call();
  return Number(lastPriceUpdateTime);
};
